import General from "./Container"

export default General
